import { PropsWithChildren } from 'react';
import LiquidityFillsListProvider from '#/leaderboard/contexts/liquidity-fills-list';

export default function LiquidityFillsProvider({
  children,
}: PropsWithChildren) {
  return <LiquidityFillsListProvider>{children}</LiquidityFillsListProvider>;
}
